import { render, staticRenderFns } from "./recording.vue?vue&type=template&id=89ea094c&scoped=true&"
import script from "./recording.vue?vue&type=script&lang=js&"
export * from "./recording.vue?vue&type=script&lang=js&"
import style0 from "./recording.vue?vue&type=style&index=0&id=89ea094c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea094c",
  null
  
)

export default component.exports